export default "__VITE_ASSET__a89f244f__"